import { Box, Divider, Typography } from "@mui/material";

const ImageWidget = ({
  id,
  label,
  schema,
  options = {},
  rawErrors = [],
}) => {

  const { labelText } = options; 

  if (!schema?.image) {
    return null; // nothing to show if no image
  }

  return (
    <Box
      id={id}
      sx={{
        p: 0.5,
        textAlign: "center",
        maxWidth: "100%",
      }}
    >
      <img
        src={schema?.image}
        alt={label || ""}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
        <Divider sx={{ borderBottomWidth: 2 }} />
        {labelText && (
          <Typography
            variant="body2"
            color="text.primary"
            sx={{ mt: 1, display: "block" ,textAlign: "left" , pl: 1 , fontSize: "14px", whiteSpace:"pre-line" }}
          >
            {labelText}
          </Typography>
        )}
    </Box>
  );
};

export default ImageWidget;
